module.exports = __webpack_public_path__ + "img/real2.1ac24cea.png";